import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

// US-6.4 framework assignment endpoints (Preview is read-only; Apply commits).
// ApiBaseResponse<FrameworkAssignmentResponse> i.e. { data: {...} }.
export const previewFramework = createAsyncThunk(
  "FrameworkAssignment/preview",
  async ({ candidateId, targetFrameworkId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.CANDIDATE.SLUG}/${candidateId}/Framework/Preview`,
        { targetFrameworkId }
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const applyFramework = createAsyncThunk(
  "FrameworkAssignment/apply",
  async (
    {
      candidateId,
      targetFrameworkId,
      notifyPush,
      notifyEmail,
      markAsNAItems,
      skipNotificationItems,
    },
    { rejectWithValue }
  ) => {
    try {
      const payload = { targetFrameworkId, notifyPush, notifyEmail };
      if (Array.isArray(markAsNAItems) && markAsNAItems.length > 0) {
        payload.markAsNAItems = markAsNAItems;
      }
      if (Array.isArray(skipNotificationItems) && skipNotificationItems.length > 0) {
        payload.skipNotificationItems = skipNotificationItems;
      }
      const { data } = await axios.post(
        `${API_URL.CANDIDATE.SLUG}/${candidateId}/Framework/Apply`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

// US-7.9 GET /api/v1/Candidate/{id}/FrameworkHistory ->
// ApiBaseResponse<FrameworkHistoryResponse[]> i.e. { data: [...] }, newest first.
export const getFrameworkHistory = createAsyncThunk(
  "FrameworkAssignment/history",
  async (candidateId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.CANDIDATE.SLUG}/${candidateId}/FrameworkHistory`
      );
      return { candidateId, items: data?.data || [] };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const frameworkAssignmentSlice = createSlice({
  name: "frameworkAssignment",
  initialState: {
    history: [],
    // which candidate the stored history belongs to / is being fetched for —
    // discards stale or late responses so one candidate never shows another's
    // history (same guard the compliance-score slice uses).
    historyCandidateId: null,
    requestedHistoryCandidateId: null,
  },
  reducers: {
    clearFrameworkHistory(state) {
      state.history = [];
      state.historyCandidateId = null;
      state.requestedHistoryCandidateId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFrameworkHistory.pending, (state, action) => {
        state.requestedHistoryCandidateId = action.meta.arg;
        state.history = [];
        state.historyCandidateId = null;
      })
      .addCase(getFrameworkHistory.fulfilled, (state, action) => {
        if (action.payload.candidateId !== state.requestedHistoryCandidateId) return;
        state.history = action.payload.items;
        state.historyCandidateId = action.payload.candidateId;
      });
  },
});

export const { clearFrameworkHistory } = frameworkAssignmentSlice.actions;
export default frameworkAssignmentSlice.reducer;
